import { filter, mergeMap, of } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { Actions } from 'Flux/Slice/index.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import type { Epic } from 'Flux/index.js'

export const DeletePoolItemEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.deletePoolItemRequest.match),
    mergeMap((action) =>
      OrderRepository.deletePoolItem({
        orderId: action.payload.orderId,
        poolId: action.payload.poolId,
        itemId: action.payload.itemId,
        version: action.payload.version
      }).pipe(
        mergeMap(() =>
          of(
            order.deletePoolItemSuccess({
              orderId: action.payload.orderId,
              poolId: action.payload.poolId,
              itemId: action.payload.itemId
            })
          )
        ),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.deletePoolItemFailure({ error }))
          })
        ),
        catchError((error: Error) => {
          console.error('Error deleting order', error)
          return of(order.deletePoolItemFailure({ error }))
        })
      )
    )
  )
